<div class="container_fluid">
  <div class="container-fluid">
    <div class="services_heading" *ngIf="!upgrade">
      <span>Choose Plan</span>
      <p>
        Pick the plan that's right for you, filled with top ways to save money.
      </p>
    </div>
    <div class="row custom_row_5 mx-0">
      <div class="col-4 basic">
        <h1>Standard</h1>
        <p>Essential tools to save you money.</p>
        <h1>Free</h1>
        <ng-container *ngIf="isBasic(); else notNowBasic">
          <button mat-stroked-button color="primary">Default</button>
        </ng-container>
        <ng-template #notNowBasic>
          <button mat-stroked-button color="primary" [routerLink]="['/signup']" *ngIf="!isUser()">Join Now</button>
        </ng-template>
        <div class="text-start" style="margin-top: 46.59px">
          <h3>
            <mat-icon class="mr-2">check</mat-icon>Access to the Don't Waste Money Reward Scheme
          </h3>
          <h3>
            <mat-icon class="mr-2">check</mat-icon>Boiler Cover or Replacement Offers
          </h3>
          <h3>
            <mat-icon class="mr-2">check</mat-icon>Home Security Offers
          </h3>
          <h3>
            <mat-icon class="mr-2">check</mat-icon>Telecom and Broadband Offers
          </h3>
          <h3>
            <mat-icon class="mr-2">check</mat-icon>Smart Home Offers
          </h3>
          <h3>
            <mat-icon class="mr-2">check</mat-icon>TV Package Offers
          </h3>
          <h3>
            <mat-icon class="mr-2">check</mat-icon>Home, Car,Insurance Offers
          </h3>
          <h4>
            <mat-icon class="mr-2">close</mat-icon>Boiler Cover or Replacement Offers with cash back
          </h4>
          <h4>
            <mat-icon class="mr-2">close</mat-icon>Home Security Offers with cash back
          </h4>
          <h4>
            <mat-icon class="mr-2">close</mat-icon>Telecom and Broadband Offers with cash back
          </h4>
          <h4>
            <mat-icon class="mr-2">close</mat-icon>Smart Home Offers with cash back
          </h4>
          <h4>
            <mat-icon class="mr-2">close</mat-icon>TV Package Offers with cash back
          </h4>
          <h4>
            <mat-icon class="mr-2">close</mat-icon>Premium Home, Car, Insurance offers
          </h4>
          <h4>
            <mat-icon class="mr-2">close</mat-icon>Tailored Discounts based on your Interests
          </h4>
          <h4>
            <mat-icon class="mr-2">close</mat-icon>Early-bird Access to our top Money-Saving Opportunities
          </h4>
        </div>
      </div>
      <div class="col-4 platinum">
        <div class="recommended">{{!isBasic() && isUser() ? 'UPGRADED' : 'RECOMMENDED'}}</div>
        <div class="platinum_content">
          <h1>Platinum</h1>
          <p>An extensive collection of top money-saving opportunities</p>
          <div class="d-flex justify-content-center mb-3 align-items-center">
            <h1 class="mb-0">£24</h1>&nbsp;
            <small>per year</small>
          </div>
          <ng-container *ngIf="upgrade || isBasic(); else upgradePlatinum">
            <button mat-flat-button color="primary" [routerLink]="['/payment']">Upgrade</button>
          </ng-container>
          <ng-template #upgradePlatinum>
            <button mat-flat-button color="primary" [routerLink]="['/signup']" *ngIf="!isUser()">Join Now</button>
          </ng-template>
          <div class="text-start">
            <p class="text-primary text-center text-uppercase mt-0" style="font-size: 12px;">Energy switch customers get
              premium for free</p>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Access to the Don't Waste Money Reward Scheme
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Boiler Cover or Replacement Offers
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Home Security Offers
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Telecom and Broadband Offers
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Smart Home Offers
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>TV Package Offers
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Home, Car,Insurance offers
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Boiler Cover or Replacement Offers with cash back
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Home Security Offers with cash back
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Telecom and Broadband Offers with cash back
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Smart Home Offers with cash back
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>TV Package Offers with cash back
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Premium Home, Car, Insurance offers
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Tailored Siscounts based on your Interests
            </h3>
            <h3>
              <mat-icon class="mr-2">check</mat-icon>Early-bird Access to our top Money-Saving Opportunities
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>